module.exports = require("react-immutable-pure-component");


//////////////////
// WEBPACK FOOTER
// external "react-immutable-pure-component"
// module id = 635
// module chunks = 0